import React, { FC, ReactElement, useCallback, useEffect, useState } from 'react';
import cns from 'classnames';
import './Counter.sass';
import { Link } from 'react-router-dom';
import Countdown from 'react-countdown';
import { useSelector } from 'react-redux';
import humanizeDuration from 'humanize-duration';
import routes from '../../../../config/routes';
import { internalizationState } from '../../../../stores/reducers/sections';
import { getContentDataIntro, getIsLoggedIn, getIsRegistrationRequired, getExhibitionNavmenuButtons, getNavmenuButtonsVisibility } from '../../../../stores/reducers/userData';
import localeFieldResolver from '../../../../helpers/locale-field-finder';
interface Props {
  className?: string;
  bgSettings?: {
    color?: string;
    isDark?: boolean;
  };
}

const Counter: FC<Props> = ({ className, bgSettings }): ReactElement => {
  const { activeLangState } = useSelector(internalizationState);
  const [isVisible, setIsVisible] = useState(true);
  const isLoggedIn = useSelector(getIsLoggedIn);
  const isRegistrationRequired = useSelector(getIsRegistrationRequired);
  const showRegisterBtn = !isLoggedIn && isRegistrationRequired;
  const { timeStart } = useSelector(getContentDataIntro);
  const { exhibitionButtonLive } = useSelector(getExhibitionNavmenuButtons);
  const liveVisible = useSelector(getNavmenuButtonsVisibility)[2];
  const liveText = localeFieldResolver(exhibitionButtonLive, 'name', activeLangState);

  const localizeData = {
    registration_ru: 'Регистрация',
    registration_en: 'Registration',
    broadcast_ru: 'Трансляция',
    broadcast_en: 'Broadcast',
    event_started_ru: 'Мероприятие началось',
    event_started_en: 'The event started',
    time_left_ru: 'До начала',
    time_left_en: 'Time left',
  };

  const localizedName = (field: string): string => localeFieldResolver(localizeData, field, activeLangState);

  const runAtDate = useCallback((date: any, func: any) => {
    const now = new Date().getTime();
    const then = date * 1000;
    const diff = Math.max(then - now, 0);
    if (diff > 0x7fffffff) {
      // max possible delay is 2^31-1
      setTimeout(() => {
        runAtDate(date, func);
      }, 0x7fffffff);
    } else {
      setTimeout(func, diff);
    }
  }, []);

  const startTime = timeStart && timeStart * 1000 - Date.now();
  useEffect(() => {
    if (startTime && startTime > 0) {
      runAtDate(timeStart, () => setIsVisible(false));
    }
  }, [startTime, timeStart, runAtDate]);

  return (
    <section
      className={cns('inner-section', 'bg-counter', 'start-section', className)}
      style={{ backgroundColor: bgSettings && bgSettings.color }}>
      <div className="shape-ptrn" />
      <div className="container">
        <div className="start-wrapper">
          <div className="start-counter f-heading">
            {(startTime && startTime < 0) || !isVisible ? (
              <span className="start-counter__tt f-main fz-header">{localizedName('event_started_ru')}</span>
            ) : (
              <>
                <span className="start-counter__tt f-main fz-header">{localizedName('time_left_ru')}:</span>
                <Countdown
                  date={Date.now() + (startTime && startTime > 0 ? startTime : 0)}
                  renderer={({ days, hours, minutes }) =>
                    startTime && (
                      <>
                        <span className="fz-header">
                          {humanizeDuration(days * 24 * 60 * 60 * 1000, { language: activeLangState, units: ['d'] })}{' '}
                        </span>
                        <span className="fz-header">
                          {humanizeDuration(hours * 60 * 60 * 1000, { language: activeLangState, units: ['h'] })}{' '}
                        </span>
                        <span className="fz-header">
                          {humanizeDuration(minutes * 60 * 1000, { language: activeLangState, units: ['m'] })}
                        </span>
                      </>
                    )
                  }
                />
              </>
            )}
          </div>
          <div className="text-center">
            {showRegisterBtn &&
              <Link className="btn btn-light--extra btn--mobile-min" to={routes.REGISTER}>
                {localizedName('registration_ru')}
              </Link>
            }
            {!showRegisterBtn && liveVisible && 
              <Link className="btn btn-light--extra btn--mobile-min" to={routes.LIVE}>
                {liveText ||  localizedName('broadcast_ru')}
              </Link>
            }
          </div>
        </div>
      </div>
    </section>
  );
};

export default Counter;
